import DropdownOption from 'components/common/select/DropdownOption';
import { T } from 'components/common/text';
import CustomText from 'components/common/text/CustomText';
import { IImplantFormat, ISeqName } from 'lib/types/clinic/projectTypes';
import { TValue } from 'lib/types/common';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface ProjectImplantProps {
  implantType: number;
  implantList: IImplantFormat[];
  implantAbutmentMaterialIdx: number | null;
  abutmentList?: ISeqName[] | null;
  implantScanbodyScanIdx: number | null;
  scanbodyList?: ISeqName[] | null;
  onImplantChange: (value: TValue) => void;
  onAbutmentMaterialChange: (value: TValue) => void;
  onScanbodyScanChange: (value: TValue) => void;
}

const ProjectImplant = ({
  implantType,
  implantList,
  implantAbutmentMaterialIdx,
  abutmentList,
  implantScanbodyScanIdx,
  scanbodyList,
  onImplantChange,
  onAbutmentMaterialChange,
  onScanbodyScanChange,
}: ProjectImplantProps) => {
  // SECTION: declare hooks
  const { t } = useTranslation();

  return (
    <StyledProjectImplant>
      <div className="projectImplant__abutment_type_box">
        <div className="projectImplant__abutment_title">
          <CustomText fontSize={20} fontColor="#222" fontWeight={600}>
            <T>PROJECT_SCAN_ABUTMENT</T>
          </CustomText>
        </div>
        <div className="projectImplant__abutment_content">
          {useMemo(() => {
            const optionList = implantList.map((implant: IImplantFormat) => {
              return { value: implant.seq, label: implant.name };
            });

            return (
              <DropdownOption value={implantType} options={optionList} onChange={onImplantChange} />
            );
          }, [implantType, implantList])}
          {useMemo(() => {
            const optionAbutmentList =
              abutmentList?.map((abutment: ISeqName) => {
                return { value: abutment.seq, label: abutment.name };
              }) || [];
            const optionScanbodyList =
              scanbodyList?.map((abutment: ISeqName) => {
                return { value: abutment.seq, label: abutment.name };
              }) || [];

            return (
              (implantType === 8 || implantType === 9) && (
                <div className="projectImplant__sub_container">
                  {implantType === 8 && (
                    <div className="projectImplang__sub_box abutment_material">
                      <div className="projectImplant__sub_title">
                        <CustomText fontSize={14} fontColor="#222" fontWeight={600}>
                          <T>PROJECT_OPTION_ABUTMENT_MATERIAL</T>
                        </CustomText>
                      </div>
                      <div className="projectImplant__sub_content">
                        {!!implantAbutmentMaterialIdx && (
                          <DropdownOption
                            value={implantAbutmentMaterialIdx}
                            options={optionAbutmentList}
                            height={40}
                            fontSize={12}
                            onChange={onAbutmentMaterialChange}
                          />
                        )}
                      </div>
                    </div>
                  )}
                  <div className="projectImplang__sub_box scanbody_scan">
                    <div className="projectImplant__sub_title">
                      <CustomText fontSize={14} fontColor="#222" fontWeight={600}>
                        <T>PROJECT_SCAN_SCANBODY</T>
                      </CustomText>
                    </div>
                    <div className="projectImplant__sub_content">
                      {!!implantScanbodyScanIdx && (
                        <DropdownOption
                          value={implantScanbodyScanIdx}
                          height={40}
                          fontSize={12}
                          options={optionScanbodyList}
                          onChange={onScanbodyScanChange}
                        />
                      )}
                    </div>
                  </div>
                </div>
              )
            );
          }, [
            implantType,
            abutmentList,
            implantAbutmentMaterialIdx,
            scanbodyList,
            implantScanbodyScanIdx,
          ])}
        </div>
      </div>
    </StyledProjectImplant>
  );
};

const StyledProjectImplant = styled.div`
  .projectImplant__abutment_type_box {
    display: flex;
    column-gap: 20px;
    .projectImplant__abutment_title {
      flex-shrink: 0;
      width: 163px;
      height: 50px;
      display: flex;
      align-items: center;
    }
    .projectImplant__abutment_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      row-gap: 10px;
      .projectImplant__sub_container {
        display: flex;
        flex-direction: column;
        background-color: #f9f9fb;
        border-radius: 18px;
        padding: 10px;
        row-gap: 10px;
        .projectImplang__sub_box {
          display: flex;
          column-gap: 16px;
          align-items: center;
          .projectImplant__sub_title {
            width: 95px;
            flex-shrink: 0;
          }
          .projectImplant__sub_content {
            width: 100%;
          }
        }
      }
    }
  }
`;

export default ProjectImplant;
